
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    const addedRoutes = router.getRoutes().filter(r => !r._initial)
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      for (const route of router.getRoutes()) {
        route._initial = true
      }
      for (const route of addedRoutes) {
        router.addRoute(route)
      }
      router.isReady().then(() => {
        // Resolve the current path against the new routes to get updated meta
        const newRoute = router.resolve(router.currentRoute.value.fullPath)
        // Clear old meta values and assign new ones
        for (const key of Object.keys(router.currentRoute.value.meta)) {
          delete router.currentRoute.value.meta[key]
        }
        Object.assign(router.currentRoute.value.meta, newRoute.meta)
      })
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
    for (const route of _router.getRoutes()) {
      route._initial = true
    }
  }
}
import { default as confirm_45password_CF67UKY7VIfZob5dHvv9PQrqiZfC_9IRuchV_K7DFMMeta } from "/app/app/pages/auth/confirm-password.vue?macro=true";
import { default as forgot_45passwordcWBzMPlUswY7UzWcOtT_Q4dvqLA7TjGm3tT6FnPUJXUMeta } from "/app/app/pages/auth/forgot-password.vue?macro=true";
import { default as loginKijtvhrcYpb5YoezFRgMHggVoPd3Q738tlQZOIojJ2EMeta } from "/app/app/pages/auth/login.vue?macro=true";
import { default as registertlYNAK5EcCkKTsZsSoML4axDqo548qPx6q2FfXG9N8cMeta } from "/app/app/pages/auth/register.vue?macro=true";
import { default as reset_45passwordC8H5LQ983yn43cMw5GMhzyEZ_Z_moAqTWCiWFxlmbLMMeta } from "/app/app/pages/auth/reset-password.vue?macro=true";
import { default as verify_45emaildf7qcW2lS74ZzzWmkTOBVmemkXXxNv_krygNszJw6XIMeta } from "/app/app/pages/auth/verify-email.vue?macro=true";
import { default as search9DjqJmACpgFQOjg00M7J5Ucm0alVPT1r7QBe4j7Rs4MMeta } from "/app/app/pages/history/search.vue?macro=true";
import { default as createBH4yIj4FsDNz_veak9RJOg10X_m9UKuY9_g_XIbFnCsMeta } from "/app/app/pages/lists/create.vue?macro=true";
import { default as _91uuid_93mCRKlEXR7CwQQBNPGArkmzZ0UTYPdeAqG8jEIMZG3OMMeta } from "/app/app/pages/lists/[uuid].vue?macro=true";
import { default as _91token_93GFWh9E5DuHtCmjEdZ4uAXD0ihdhkQg7ECvx85pfjTvAMeta } from "/app/app/pages/share/[token].vue?macro=true";
import { default as dashboard6diNbqY5xeu6jgOTisimm62NDPPD5BXoozGRMTcqEDYMeta } from "/app/app/pages/dashboard.vue?macro=true";
import { default as demoTt5F4AR99KtQilp2zmRRjEgs3Oqsiv6iULdbouiC3OUMeta } from "/app/app/pages/demo.vue?macro=true";
import { default as indexxu0t0zbpxoiywvJEGokP5u06UxKZB1HDvZGzGHZdXDEMeta } from "/app/app/pages/history/index.vue?macro=true";
import { default as homewCL8ohGwYXHZ_VFxToLGZta5J_Bjj6J02q_xQvczRHcMeta } from "/app/app/pages/home.vue?macro=true";
import { default as indexQt556il_qTz2Il2xTGEJVrtjUb93Vr0F_M_MFC7lu4EMeta } from "/app/app/pages/lists/index.vue?macro=true";
import { default as indexNx4HXOLtc0PHmjHaIri3I1466Zt6KBI06f8tZn6jlwsMeta } from "/app/app/pages/notifications/index.vue?macro=true";
import { default as offlinenCJDlmUK9hHsneedxfGVNcAFfWLLt8RKiSe0S5hUqCoMeta } from "/app/app/pages/offline.vue?macro=true";
import { default as indexLdNUQ4MIhBpg7fAzfpvdMU7gu9Bg6nib_8MieNFMpMUMeta } from "/app/app/pages/profile/index.vue?macro=true";
import { default as index4nVS2Dd4a5t9zrU2j8coCxsqtPYupm_GEv_2EzeGhJUMeta } from "/app/app/pages/index.vue?macro=true";
export default [
  {
    name: "auth-confirm-password",
    path: "/auth/confirm-password",
    meta: {"middleware":"auth"},
    component: () => import("/app/app/pages/auth/confirm-password.vue")
  },
  {
    name: "auth-forgot-password",
    path: "/auth/forgot-password",
    meta: {"middleware":"guest"},
    component: () => import("/app/app/pages/auth/forgot-password.vue")
  },
  {
    name: "auth-login",
    path: "/auth/login",
    meta: {"middleware":"guest"},
    component: () => import("/app/app/pages/auth/login.vue")
  },
  {
    name: "auth-register",
    path: "/auth/register",
    meta: {"middleware":"guest"},
    component: () => import("/app/app/pages/auth/register.vue")
  },
  {
    name: "auth-reset-password",
    path: "/auth/reset-password",
    meta: {"middleware":"guest"},
    component: () => import("/app/app/pages/auth/reset-password.vue")
  },
  {
    name: "auth-verify-email",
    path: "/auth/verify-email",
    component: () => import("/app/app/pages/auth/verify-email.vue")
  },
  {
    name: "history-search",
    path: "/history/search",
    meta: {"middleware":"auth"},
    component: () => import("/app/app/pages/history/search.vue")
  },
  {
    name: "lists-create",
    path: "/lists/create",
    meta: {"middleware":"auth"},
    component: () => import("/app/app/pages/lists/create.vue")
  },
  {
    name: "lists-uuid",
    path: "/lists/:uuid()",
    meta: {"middleware":"auth"},
    component: () => import("/app/app/pages/lists/[uuid].vue")
  },
  {
    name: "share-token",
    path: "/share/:token()",
    component: () => import("/app/app/pages/share/[token].vue")
  },
  {
    name: "dashboard",
    path: "/dashboard",
    meta: {"middleware":"auth"},
    component: () => import("/app/app/pages/dashboard.vue")
  },
  {
    name: "demo",
    path: "/demo",
    component: () => import("/app/app/pages/demo.vue")
  },
  {
    name: "history",
    path: "/history",
    meta: {"middleware":"auth"},
    component: () => import("/app/app/pages/history/index.vue")
  },
  {
    name: "home",
    path: "/home",
    meta: {"middleware":"auth"},
    component: () => import("/app/app/pages/home.vue")
  },
  {
    name: "lists",
    path: "/lists",
    meta: {"middleware":"auth"},
    component: () => import("/app/app/pages/lists/index.vue")
  },
  {
    name: "notifications",
    path: "/notifications",
    meta: {"middleware":"auth"},
    component: () => import("/app/app/pages/notifications/index.vue")
  },
  {
    name: "offline",
    path: "/offline",
    component: () => import("/app/app/pages/offline.vue")
  },
  {
    name: "profile",
    path: "/profile",
    meta: {"middleware":"auth"},
    component: () => import("/app/app/pages/profile/index.vue")
  },
  {
    name: "index",
    path: "/",
    component: () => import("/app/app/pages/index.vue")
  }
]